const { AllSocialMedia } = require("../features/admin/common/Slice");

exports.APIS = {
  Auth: "/common/auth/admin-login",
  ChangePassword: "/common/auth/change-password",

  Masters: {
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    LearnMore: "/admin/masters/learn-more",

    PrivacyAgreement: "/admin/masters/privacy-agreement",
    RiskDisclosure: "/admin/masters/risk-disclosure",
    ComplaintHandlingPolicy: "/admin/masters/complaint-handling-policy",
    LegalDocument: "/admin/masters/legal-document",
    SecurityInstruction: "/admin/masters/security-instruction",
    PreventingMoneyLaundering: "/admin/masters/preventing-money-laundering",

    MarketNews: "/admin/masters/market-news",
  },

  Company: {
    Company: "/admin/masters/company",
  },

  Notice: {
    notice: "/admin/notice",
  },

  ChangeStock: {
    Company: "/admin/change-stock/new-marketprice",
    MarketPriceHistory: "/admin/change-stock/new-marketprice-history",
  },

  AllTrade: {
    all_trade: "/admin/all-trade",
  },

  AllWalletHistory: {
    wallet_history: "/admin/wallet-history",
    withdraw_request: "/admin/wallet-history/withdraw-request",
    deposit_request: "/admin/wallet-history/deposit-request",
  },

  // common
  Commons: {
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllDistrict: "/common/masters/all-district",
    AllPincode: "/common/masters/all-pincode",
    AllCategory: "/common/masters/all-category",
    AllSubCategory: "/common/masters/all-subcategory",
    AllChildCategory: "/common/masters/all-childcategory",
    AllPartners: "/common/masters/all-partners",
    AllWhyChooseUs: "/common/masters/all-whychooseus",
    AllIndustry: "/common/masters/all-industry",
    AllDepartment: "/common/masters/all-department",
    AllCompanySize: "/common/masters/all-companysize",
    AllNeeds: "/common/masters/all-needs",
    AllFaq: "/common/masters/all-faqs",
    AllSubFaq: "/common/masters/all-subfaq",
    AllSocialMedia: "/common/masters/all-socialmedia",
    AllUserStatus: "/common/masters/all-user-status",
    AllCompany: "/common/masters/all-company",
    AllWithdrawStatus: "/common/masters/all-withdraw-status",
    AllUser: "/common/masters/all-users",
  },

  //Customer
  Customer_Management: {
    customer: "/admin/customer-management/customer",
  },

  //Wallet
  Wallet: {
    wallet_history: "/admin/wallet/wallet-history",
    intrest_history: "/admin/wallet/intrest-history",
    commission_history: "/admin/wallet/commission-history",
    about_me: "/admin/wallet/about-me",
  },

  //Customization
  Customization: {
    AppSetUp: "/admin/customization/app-setup",
  },

  //Profile Feed
  ProfileFeed: {
    AboutUs: "/admin/profile-feed/about-us",
    TermsAndCondition: "/admin/profile-feed/terms-and-condition",
    PrivacyPolicy: "/admin/profile-feed/privacy-policy",
    RefundPolicy: "/admin/profile-feed/refund-policy",
  },

  FundRequest: {
    fundRequest: "/admin/fund-request",
  },

  WithdrawlRequest: {
    withdrawlRequest: "/admin/withdrawl-request",
  },

  // Dashboard
  Dashboard: {
    dashboard: "/admin/dashboard",
  },

  //Rating And Feedback
  RatingAndFeedback: {
    feedback: "/admin/rating/feedback",
  },
};
